module.exports = "//public.zight.com/packs/media/images/installer-1e54b163983e67a851e04d53f8a525a8.svg";